import { useQuery } from '@tanstack/react-query';
import { manhoursApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

/** @registry Division / base-cost-code / cost-code options for the manhours filters. */
export function useManhoursFilters() {
  return useQuery({
    queryKey: queryKeys.manhours.filters(),
    queryFn: ({ signal }) =>
      manhoursApiClient.listJobFilters(toCancelToken(signal)),
    staleTime: 5 * 60_000,
    meta: { errorContext: 'manhours filters' },
  });
}
